import React from "react";
import DotsComponent from './DotsComponent';
import { purchaseCardData as data} from "./OMSData";
import { useState, useEffect } from "react";

export default function OMSPurchaseCard() {
  const [style, setstyle] = useState({backgroundColor:'#F72E2E'})
  useEffect(() =>{
    if (data.availibility) {
      setstyle({backgroundColor:'#43991F'})
    } else {
      setstyle({backgroundColor:'#F72E2E'})
    }
  }, [])

  return (
    <div id="PurchaseOrderSmallWindow">
    <DotsComponent />
    <div className="purchase-card">
      <small className="detail-light purchase-head">Order Details</small>
      <div id="PurchaseOrderDetail">
        <div className="order-details-head" style={style}>
          <b>Delivered</b>
        </div>
        <div className="order-detail-id">
          <h3>Order Id: 8789546585</h3>
          <small>Ordered On: 18-18-18</small>
        </div>
        <div className="order-detail-contact">
          <p className="detail-light">Contact Details: <span className="detail-dark">+91 {data.phone}</span></p>
          <p className="detail-light">Delivery Partner: <span className="detail-dark">{data.deliveryPartner}</span></p>
          <p className="detail-light">Delivery Partner Name: <span className="detail-dark">{data.deliveryPartnerName}</span></p>
          <p className="detail-light">Email Id: <span className="detail-dark">{data.mail}</span></p>
          <p className="detail-light">No of times ordered: <span className="detail-dark">{data.noOfItems}</span></p>
        </div>
        <div className="order-details-items">
          <small>Items:</small>
          {data.item.map((val) =>{
            return (
              <div className='order_detail'>
                <img src={val.img}/>
                <div style={{padding:'5px',lineHeight:'20px'}}>
                <p className="detail-dark">{val.name}</p>
                <p className="detail-light">{val.qty}</p>
                <p className="detail-light">{val.brand}</p>
                <p className="detail-dark">Rs. {val.price}</p>
                </div>
              </div>
            )
          })}
        </div>
        <hr/>
        <div className="detail-dark detail-total">Total Amount: <span>Rs. {data.total}</span></div>
      </div>
    </div>
    </div>
  );
}
